import React from "react";
import Gif from "../../../imgs/htmlAdvert2/Consilient-Health-Cadelius-GP-Consult.gif";

export const HTMLAdvert2 = ({hide, onClick, links}) => {
  const handleGifLoad = () => {
    const frameDurations = [2000, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 2000, 2000, 2000];
    const totalDuration = frameDurations.reduce((a,b)=>a+b,0);
    let apiFrameIndices = new Set([63]);
    const API_URL = links ? links.api : "https://www.consilienthealth.ie/cadelius/wp-content/uploads/sites/7/2025/12/Cadelius-API_IECAS081700023-3-2.pdf?utm_source=Cadelius+GP+Consult+ROS&utm_medium=Cadelius+MPU+on+GP+Consult+ROS&utm_campaign=Cadelius+3+differentiation+messages&utm_id=Cadelius+GP+Consult+ROS&utm_term=Cadelius+GP+Consult+ROS&utm_content=Cadelius+GP+Consult+ROS";
    const DEFAULT_URL = links ? links.default : "https://www.consilienthealth.ie/cadelius/?utm_source=Cadelius+GP+Consult+ROS&utm_medium=Cadelius+MPU+on+GP+Consult+ROS&utm_campaign=Cadelius+3+differentiation+messages&utm_id=Cadelius+GP+Consult+ROS&utm_term=Cadelius+GP+Consult+ROS&utm_content=Cadelius+GP+Consult+ROS";

    function currentFrameAt(ms) {
      let acc = 0;
      for (let i=0; i<frameDurations.length; i++) {
        acc += frameDurations[i];
        if (ms < acc) return i;
      }
      return frameDurations.length - 1;
    }

    const anchor = document.getElementById('clickLayer');

    let started = false;

    if (started) return;
    started = true;
    const start = performance.now();
    console.log("gif loaded");

    function tick(now) {
      const elapsed = (now - start) % totalDuration;
      const frameIdx = currentFrameAt(elapsed);
      if (apiFrameIndices.has(frameIdx)) {
        anchor.href = API_URL;
      } else {
        anchor.href = DEFAULT_URL;
      }
      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  };

  return !hide && (
    <div className="banner-wrap">
      <img id="cadeliusGif" src={Gif} onLoad={handleGifLoad} />
      <a
        id="clickLayer"
        className="click-layer"
        onClick={onClick}
        href={
          links ?
            links.defaut :
            "https://www.consilienthealth.ie/cadelius/?utm_source=Cadelius+GP+Consult+ROS&utm_medium=Cadelius+MPU+on+GP+Consult+ROS&utm_campaign=Cadelius+3+differentiation+messages&utm_id=Cadelius+GP+Consult+ROS&utm_term=Cadelius+GP+Consult+ROS&utm_content=Cadelius+GP+Consult+ROS"}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Cadelius link"
      ></a>
    </div>
  );
};